module.exports = __webpack_public_path__ + "static/media/paint.f4e7a627.jpg";